export default "__VITE_ASSET__DTeQlLxU__"